<template>
    <v-card elevation="3" class="insight-card rounded d-flex flex-column">
        <v-card-title class="d-flex align-center py-2 px-4">
            <v-icon :color="iconColor" size="20" class="mr-2">{{ icon }}</v-icon>
            <span class="text-subtitle-2 font-weight-bold"
                  :class="{'cursor-pointer text-primary': linkable}"
                  @click="linkable ? $emit('titleClick') : null">{{ title }}</span>
            <v-spacer/>
            <v-chip v-if="count !== null && count !== undefined" :color="chipColor" size="small" variant="tonal">
                {{ count }}
            </v-chip>
        </v-card-title>
        <v-divider/>
        <v-card-text class="flex-grow-1 pa-3">
            <slot/>
        </v-card-text>
    </v-card>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
    title: {type: String, required: true},
    icon: {type: String, required: true},
    iconColor: {type: String, default: 'primary'},
    count: {type: [Number, String], default: null},
    countColor: {type: String, default: null},
    linkable: {type: Boolean, default: false},
});
defineEmits(['titleClick']);

const chipColor = computed(() => {
    if (props.countColor) return props.countColor;
    const num = Number(props.count);
    return num > 0 ? 'red' : 'green';
});
</script>

<style scoped>
.insight-card {
    height: 100%;
}
</style>
